import { Flex, useMantineTheme } from "@mantine/core";
import { TickCircle, Timer1 } from "iconsax-react";
import { IMyPlans } from "../../../../interfaces/MyPlans/IMyPlans";
import { useMediaQuery } from "@mantine/hooks";
import { useTranslation } from "react-i18next";

interface IProps {
  product: IMyPlans;
}

export default function StepsNew({ product }: IProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();
  const isAcceptedTerm = !!product?.is_accepted_term;
  const isAlgorithmRunning = !!product?.is_algorithm_running;
  const hasScheduledActions = !!product?.has_pending_scheduled_actions;

  return (
    <Flex
      gap="10px"
      align="center"
      justify="center"
      fz="16px"
      fw={500}
      c={theme.colors.basic[5]}
    >
      {isAcceptedTerm && isAlgorithmRunning ? (
        <>
          <TickCircle size={28} color={theme.colors.alerts[2]} variant="Bold" />
          {t("meu_portfolio.minhas_compras.card_product.steps.steps_completed")}
        </>
      ) : (
        <>
          <Timer1 size={28} color={theme.colors.alerts[1]} variant="Bold" />
          {hasScheduledActions
            ? t(
                "meu_portfolio.minhas_compras.card_product.steps.scheduled_actions_description"
              )
            : t("meu_portfolio.minhas_compras.card_product.steps.step_one")}
        </>
      )}
    </Flex>
  );
}
